<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card>
          <v-card-title>
            {{ this.title }}
          </v-card-title>
          <v-container fluid>
            <v-row>
              <v-container fluid>
                <v-select
                  :items="options"
                  item-value="value"
                  item-text="text"
                  v-model="selected"
                  label="Select a flight"
                  outlined
                  style="margin:0px"
                ></v-select>
                URL: <a :href="selected" target="_blank">{{ this.selected }}</a><br />
                <video :src="selected" controls autoplay width="800px">
                  Your browser does not support the video tag.
                </video>
              </v-container>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    dense: false,
    fixedHeader: false,
    height: 300,
    docs: [],
    docsURL: [],
    images: [],
    kmls: [],
    selected: [],
    options: [],
    pathFile: "",
    show_imgs: false
  }),
  props: {
    path: String,
    title: {
      type: String,
      default: "Documents"
    },
    selectBox: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getResults: function() {
      this.show_imgs = false;
      this.docs = [];
      this.docsURL = [];
      this.images = [];
      this.options = [];
      let wurl =
        "https://observations.ipsl.fr/aeris/eurec4aprod/list.php?p=" +
        this.pathFile;
      wurl = wurl + "&gen=true&sep=other";

      axios.get(wurl).then(response => {
        let tab = response.data;
        if (typeof tab.length === "undefined") {
          console.log(response.data);
          for (let p in response.data) {
            console.log(response.data[p] + "--" + p);
            this.options.push(p);
            this.selected = p;
            tab = response.data[p];
          }
        } else if (tab.length > 1) {
          for (let i = 0; i < tab.length; i++) {
            /*this.options.push(
              "https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i]
            );*/
            let f = tab[i].split(/[\\\/]/).pop();
            this.options.push({
              value:
                "https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i],
              text: f
            });
            this.selected =
              "https://observations.ipsl.fr/aeris/eurec4a-data/" + tab[i];
          }
        }
      });
    }
  },
  mounted: function() {
    this.pathFile = this.path;
    this.getResults();
  },
  computed: {
    getContent() {
      return this.path;
    }
  },
  watch: {
    getContent(newContent, oldContent) {
      this.pathFile = newContent;
      this.getResults();
    }
  }
};
</script>
